import React, { useEffect } from "react";
import {
  ComponentRef,
  getComponentRef,
} from "../../message/components/records/MessageTagUtil";

export default function Metadata(props) {
  const {
    handleSubComponentLoaded = (
      subComponent = { ...ComponentRef },
      isLoaded = false
    ) => {},
  } = props;
  const { itemIndex, level, messageTime } = props;

  useEffect(() => {
    handleSubComponentLoaded(
      getComponentRef("Metadata", itemIndex, level, messageTime),
      true
    );
  }, []);

  // Metadata component shouldn't render anything. It's for saving data only.
  return false;
}
